module.exports = __webpack_public_path__ + "img/11n@2x.7142c78b.svg";